import { Injectable } from '@angular/core';
import { ControllerType, HttpClientService } from '../http-client.service';
import { firstValueFrom, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DeliveryMethodService {

  constructor(private httpClientService: HttpClientService) { }
  async getAllDeliveryMethod(page, size) {
    const observable: Observable<any> = this.httpClientService.get({
      controller: ControllerType.DeliveryMethod,
      queryString: `Page=${page}&Size=${size}`
    });
    return await firstValueFrom(observable);
  }

  async createDeliveryMethod(deliveryMethod) {
    const observable: Observable<any> = this.httpClientService.post({
      controller: ControllerType.DeliveryMethod
    },
      {
        name: deliveryMethod
      });
    return await firstValueFrom(observable);
  }

  async updateDeliveryMethod(id,deliveryMethod){
    const observable:Observable<any> = this.httpClientService.put({
      controller:ControllerType.DeliveryMethod
    },{
      id:id,
      name:deliveryMethod
    });
    return await firstValueFrom(observable);
  }

  private eventSubject = new Subject<boolean>();

  event$ = this.eventSubject.asObservable();

  sendEvent(result: boolean) {
    this.eventSubject.next(result);
  }
}
